import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { SafeHtmlPipe } from '@shared/pipes'
import { NoticeContentService } from '@shared/services/notice-content.service'
import { Observable } from 'rxjs'


@Component({
    selector: 'app-notice',
    templateUrl: './notice.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        SafeHtmlPipe,
    ]
})

export class NoticeComponent {

    noticeContent: Observable<string>
    constructor(private noticeContentService: NoticeContentService){
        this.noticeContent = noticeContentService.noticeContent$
    }

}
